'use client';

import { useParams } from 'next/navigation';

import { getLocale, Locale } from '../i18n/routing';

export function useLocale(): Locale {
  const params = useParams();

  return getLocale(String(params.locale));
}
